import Swal from "sweetalert2";

export const ValidardocumentoSC = (state) => {
  // console.log(state.vencimiento)
  if (state === undefined || state === null) {
    Swal.fire("Clientes", "Favor de actualizar la aplicación", "error");
    return false;
  }
  if (
    state.documento === undefined ||
    state.documento === null ||
    state.documento.length === 0
  ) {
    Swal.fire("Clientes", "El documento es obligatorio", "error");
    return false;
  }
  if (
    state.vencimiento === undefined ||
    state.vencimiento === null ||
    state.vencimiento.length === 0
  ) {
    Swal.fire("Clientes", "El vencimiento es obligatorio", "error");
    return false;
  }
  return {
    folio: "",
    iddocumento: "",
    documento: state.documento,
    nombreDocumento: "",
    extension: state.extension,
    vigencia: state.vencimiento,
    comentarios:
      state.comentarios === undefined ||
        state.comentarios === null ||
        state.comentarios === ""
        ? " "
        : state.comentarios,
  };
};
